type FetchStoresErrorHandlerType = {
  error: Error;
  errorLogger: (error: string | Error) => void;
};

const ignoredError = [
  "zipCode could not be found",
  "No zip code, latitude or longitude provided",
];

const fetchStoresErrorHandler = ({
  error,
  errorLogger,
}: FetchStoresErrorHandlerType): void => {
  if (!ignoredError.includes(error.message)) {
    errorLogger(error);
  }
};

export {fetchStoresErrorHandler};
